
export default function Relax() {
  return (
    <section id="relaks" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            Relaks i Wellness
          </h2>
          <div className="w-24 h-1 bg-stone-300 mx-auto mb-8"></div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-stone-50 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div className="relative h-64">
              <img 
                src="https://i.imgur.com/l0yUELF.jpg" 
                alt="Baseny" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-4">
                <i className="ri-water-flash-line text-blue-700 text-xl"></i>
              </div>
              <h3 className="text-2xl font-light text-stone-800 mb-3">Baseny</h3>
              <p className="text-stone-600 leading-relaxed">
                Kilka basenów w różnych lokalizacjach hotelu, w tym basen z wodą morską, basen dla dzieci i strefy relaksu z leżakami i parasolami.
              </p>
            </div>
          </div>
          
          <div className="bg-stone-50 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div className="relative h-64">
              <img 
                src="https://i.imgur.com/7muzm0L.jpg" 
                alt="Pura Vida" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mb-4">
                <i className="ri-heart-line text-green-700 text-xl"></i>
              </div>
              <h3 className="text-2xl font-light text-stone-800 mb-3">Pura Vida</h3>
              <p className="text-stone-600 leading-relaxed">
                Strefa wellness z jacuzzi, sauną i przestrzeniami do relaksu. Idealne miejsce na regenerację po dniu pełnym wrażeń.
              </p>
            </div>
          </div>
          
          <div className="bg-stone-50 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div className="relative h-64">
              <img 
                src="https://i.imgur.com/KPOY6FA.jpg" 
                alt="Spa Ahemon" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full mb-4">
                <i className="ri-heart-pulse-line text-purple-700 text-xl"></i>
              </div>
              <h3 className="text-2xl font-light text-stone-800 mb-3">Spa Ahemon (+16)</h3>
              <p className="text-stone-600 leading-relaxed">
                Ekskluzywne spa tylko dla dorosłych z profesjonalnymi zabiegami, masażami, sauną i strefą relaksu. Oaza spokoju i regeneracji.
              </p>
            </div>
          </div>
        </div>

        {/* Removed Spa Gallery Section and Beach Club Laurel reminder */}
      </div>
    </section>
  );
}
